// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-businessServices-services-bsBom3-Bom3Positions-Bom3Positions-module__box--IOAgI {
  flex: 1;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding-top: 12px;
}
.src-businessServices-services-bsBom3-Bom3Positions-Bom3Positions-module__head--fcMxH {
  padding: 0 24px;
  display: flex;
  align-items: center;
}
.src-businessServices-services-bsBom3-Bom3Positions-Bom3Positions-module__head--fcMxH .src-businessServices-services-bsBom3-Bom3Positions-Bom3Positions-module__left--lzvrs {
  flex: 1;
  display: flex;
  gap: 16px;
  align-items: center;
}
.src-businessServices-services-bsBom3-Bom3Positions-Bom3Positions-module__head--fcMxH .src-businessServices-services-bsBom3-Bom3Positions-Bom3Positions-module__left--lzvrs .src-businessServices-services-bsBom3-Bom3Positions-Bom3Positions-module__name--BzeBr {
  font-size: 20px;
  font-weight: 700;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
.src-businessServices-services-bsBom3-Bom3Positions-Bom3Positions-module__head--fcMxH .src-businessServices-services-bsBom3-Bom3Positions-Bom3Positions-module__right--qX70a {
  display: flex;
  gap: 16px;
  align-items: center;
}
`, "",{"version":3,"sources":["webpack://./src/businessServices/services/bsBom3/Bom3Positions/Bom3Positions.module.less"],"names":[],"mappings":"AAAA;EACE,OAAA;EACA,gBAAA;EAEA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,iBAAA;AAAF;AAKA;EACE,eAAA;EACA,aAAA;EACA,mBAAA;AAHF;AAAA;EAKI,OAAA;EACA,aAAA;EACA,SAAA;EACA,mBAAA;AAFJ;AANA;EAUM,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;AADN;AAbA;EAkBI,aAAA;EACA,SAAA;EACA,mBAAA;AAFJ","sourcesContent":[".box {\n  flex: 1;\n  overflow: hidden;\n\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  padding-top: 12px;\n}\n\n@horizSpace: 24px;\n\n.head {\n  padding: 0 @horizSpace;\n  display: flex;\n  align-items: center;\n  .left {\n    flex: 1;\n    display: flex;\n    gap: 16px;\n    align-items: center;\n    .name {\n      font-size: 20px;\n      font-weight: 700;\n      text-overflow: ellipsis;\n      white-space: nowrap;\n      overflow: hidden;\n    }\n  }\n  .right {\n    display: flex;\n    gap: 16px;\n    align-items: center;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"box": `src-businessServices-services-bsBom3-Bom3Positions-Bom3Positions-module__box--IOAgI`,
	"head": `src-businessServices-services-bsBom3-Bom3Positions-Bom3Positions-module__head--fcMxH`,
	"left": `src-businessServices-services-bsBom3-Bom3Positions-Bom3Positions-module__left--lzvrs`,
	"name": `src-businessServices-services-bsBom3-Bom3Positions-Bom3Positions-module__name--BzeBr`,
	"right": `src-businessServices-services-bsBom3-Bom3Positions-Bom3Positions-module__right--qX70a`
};
export default ___CSS_LOADER_EXPORT___;
